import { IconChevronLeft } from '@tabler/icons-react';
import { ActionIcon, Avatar, Group, Text } from '@mantine/core';
import { MChatConversation } from '@/src/modules/chat/models/chat-conversation';

interface IChatConversationHeaderProps {
  size?: 'sm' | 'md';
  overrideName?: string;
  conversation: MChatConversation | null;
  withBackButton?: boolean;
  onBackButtonClick?: () => void;
  avatar?: React.ReactNode;
  actions?: React.ReactNode;
}

export function ChatConversationHeader({
  size = 'md',
  overrideName,
  conversation,
  withBackButton = false,
  onBackButtonClick,
  avatar,
  actions,
}: IChatConversationHeaderProps) {
  const isNormalSize = size === 'md';
  const displayName = overrideName ?? conversation?.props.recipient.props.name;

  return (
    <Group
      p="sm"
      justify={conversation ? 'space-between' : 'end'}
      align="center"
    >
      <Group gap={conversation ? 'md' : 0}>
        {withBackButton && (
          <ActionIcon
            variant="transparent"
            color="black"
            onClick={onBackButtonClick}
          >
            <IconChevronLeft />
          </ActionIcon>
        )}

        {conversation && (
          <>
            {!avatar ? (
              <Avatar
                name={displayName}
                alt={displayName}
                size={isNormalSize ? 'md' : '2.2rem'}
                color="initials"
              />
            ) : (
              avatar
            )}

            <Text fw="bold" fz={isNormalSize ? '0.9rem' : 'sm'} lineClamp={1}>
              {displayName}
            </Text>
          </>
        )}
      </Group>

      {actions}
    </Group>
  );
}
